var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisableTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_265_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 15C1 7.28095 7.28095 1 15 1C22.719 1 29 7.28095 29 15C29 22.719 22.719 29 15 29C7.28095 29 1 22.719 1 15Z",
    stroke: "#706E84",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6024 11.8211L14.4773 19.946C14.2335 20.1897 13.9135 20.3124 13.5936 20.3124C13.2736 20.3124 12.9536 20.1897 12.7099 19.946L8.64743 15.8835C8.15854 15.3949 8.15854 14.6048 8.64743 14.1161C9.13609 13.6272 9.92596 13.6272 10.4149 14.1161L13.5936 17.2948L20.8349 10.0537C21.3236 9.56479 22.1135 9.56479 22.6024 10.0537C23.091 10.5423 23.091 11.3322 22.6024 11.8211Z",
    fill: "#706E84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_265_544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableTick);
export default __webpack_public_path__ + "static/media/disable_tick.85b07481d119a02674c10ebc9b1cd265.svg";
export { ForwardRef as ReactComponent };